import { useState } from 'react';
import { faqList } from '@/mocks/anime';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            关于91动漫
          </h2>
          <p className="text-sm text-foreground-500 mt-2">解答你最关心的问题</p>
        </div>

        <div className="flex flex-col gap-3">
          {faqList.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <h3 className="text-sm font-semibold text-foreground-900 pr-4">{faq.question}</h3>
                <div className={`w-8 h-8 flex items-center justify-center rounded-lg transition-all duration-300 flex-shrink-0 ${
                  openIndex === index ? 'bg-primary-500 text-white rotate-180' : 'bg-background-100 text-foreground-500'
                }`}>
                  <i className="ri-arrow-down-s-line text-lg"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-60 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}